import { useLayoutEffect } from 'react'
import { api } from 'src/utils/api'

const useHeadTags = () => {
  useLayoutEffect(() => {
    const faviconHref = api.config.FAVICON
    const title = api.config.PAGE_TITLE
    const titleTag: HTMLTitleElement | null =
      document.querySelector('title') || document.createElement('title')
    const linkTag: HTMLLinkElement | null =
      document.querySelector("link[rel~='icon']") ||
      document.createElement('link')

    linkTag.rel = 'icon'
    linkTag.type = 'image/svg+xml'
    linkTag.href = faviconHref
    titleTag.textContent = title
    document.head.appendChild(linkTag)
    document.head.appendChild(titleTag)
    return () =>
      [linkTag, titleTag].forEach((element) => document.removeChild(element))
  }, [])
  return null
}

export default useHeadTags
